<template>
  <textarea
    v-if="type === 'textarea'"
    v-bind="$attrs"
    v-on="listeners"
    ref="textarea"
    :class="b('control')"
    :value="value"
    :placeholder="placeholder"
  />
  <input
    v-else
    v-bind="$attrs"
    v-on="listeners"
    :class="b('control')"
    :type="type"
    :value="value"
    :placeholder="placeholder"
  />
</template>

<script>
import create from '../utils/create';
import { isIphone } from '../utils';

export default create({
  name: 'input',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {},
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
        keypress: this.onKeypress,
        blur: this.iosKeyboardFixer,
      };
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.value);
    },
    onKeypress(event) {
      if (this.type === 'number') {
        const { keyCode } = event;
        const tempValue = '' + this.value
        const allowPoint = tempValue.indexOf('.') === -1;
        const isValidKey = (keyCode >= 48 && keyCode <= 57) || (keyCode === 46 && allowPoint) || keyCode === 45;
        if (!isValidKey) {
          event.preventDefault();
        }
      }
      this.$emit('keypress', event);
    },
    iosKeyboardFixer (e) {
      if (!isIphone()) {
        return
      }
      window.scroll(0, 0)
    }
  }
})

</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/input/index.vue